/* tl-cachebust-20260904-lineflick */
window.__tlLinePdp = window.__tlLinePdp || /\/products\/(sauteerpan|twee-handgrepen|wok-vlakke-bodem|hoge-rand|diepe-pan|crepepan|kookpan)(?:\/|$)/.test((location.pathname || '').toLowerCase());
if (window.__tlLinePdp) window.__tgemSiteStickyBoot = true;

/* tl-cachebust-20260830-origwas */

/* tl-dedupe-offer-boot-20260818-nl */
(function(){try{
  if (window.__tlLinePdp) return;
  function isNl(){var p=(location.pathname||'').toLowerCase();return p==='/nl'||p.indexOf('/nl/')===0;}
  var LABEL=isNl()?'2 producten 10% extra · 3 of meer 20% extra':'2 products 10% extra · 3 or more 20% extra';
  function kill(){
    if (document.querySelector('#tl-sale-merch, [data-tl-sale-lp], .tl-sale')) {
      document.documentElement.classList.add('tl-sale-no-offer');
      document.querySelectorAll('.shopify-section.section-titanore-offer-bar, .titanore-offer-bar, .titanore-offer-bar .tob-inner').forEach(function(el){
        el.style.setProperty('display','none','important');
      });
      return;
    }
    document.querySelectorAll('#okhSummerStrip,#tlSummerStripLive').forEach(function(el){el.remove();});
    document.querySelectorAll('.shopify-section.section-titanore-top-offer').forEach(function(el){el.style.display='none';});
    var n=0; document.querySelectorAll('.shopify-section.section-titanore-offer-bar').forEach(function(el){n++; if(n>1) el.style.display='none';});
    var sale=document.querySelector('.titanore-offer-bar .tob-sale');
    if(sale){ sale.querySelectorAll('.tob-mark').forEach(function(m){m.remove();}); sale.setAttribute('translate','no'); sale.textContent=LABEL; }
  }
  kill();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', kill);
  setTimeout(kill,300); setTimeout(kill,1000);
}catch(e){}})();

/* titanore-be-nl-boot-v1 */
(function () {
  var DUTCH_COUNTRIES = { BE: 1, NL: 1 };
  var PREF_KEY = 'tl_lang_pref';
  var path = location.pathname || '';
  var pathLower = path.toLowerCase();
  if (pathLower === '/nl' || pathLower.indexOf('/nl/') === 0) return;
  function getPref() {
    try { return localStorage.getItem(PREF_KEY) || ''; } catch (e) { return ''; }
  }
  if (getPref() === 'en' || getPref() === 'fr') return;
  var params;
  try { params = new URLSearchParams(location.search); } catch (e) { params = null; }
  var qLang = params ? (params.get('locale') || params.get('lang') || '').toLowerCase() : '';
  if (qLang === 'en' || qLang === 'fr') {
    try { localStorage.setItem(PREF_KEY, qLang); } catch (e) {}
    return;
  }
  function toNl() {
    location.replace('/nl' + (path === '/' ? '/' : path) + location.search + location.hash);
  }
  if (qLang === 'nl') { toNl(); return; }
  var qCountry = params ? (params.get('country') || '').toUpperCase() : '';
  if (DUTCH_COUNTRIES[qCountry]) { toNl(); return; }
  function cookieCountry() {
    var m = document.cookie.match(/(?:^|; )localization=([^;]*)/);
    return m ? decodeURIComponent(m[1]).toUpperCase() : '';
  }
  if (DUTCH_COUNTRIES[cookieCountry()]) { toNl(); return; }
  try {
    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (getPref() === 'en' || getPref() === 'fr') return;
        var p2 = (location.pathname || '').toLowerCase();
        if (p2 === '/nl' || p2.indexOf('/nl/') === 0) return;
        var handle = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (handle && DUTCH_COUNTRIES[String(handle).toUpperCase()]) toNl();
      })
      .catch(function () {});
  } catch (e) {}
})();

/**
 * Sitewide Chef’s Pan sticky ATC
 * - GEM buybox pages: contrast + thumb only (native [data-tgem-sticky] owns UI)
 * - Chef’s Pan PDPs: match Small / Medium / Large
 * - GEM size UI present: sync selected size
 * - Everywhere else: Medium default (€99 / market presentment from buybox DOM)
 * cachebust-2026-08-11-buybox-trim
 */
(function () {
  var pathEarly = (window.location.pathname || '').replace(/\/$/, '').toLowerCase();
  if (window.__tlLinePdp) return;
  /* Line PDPs own their buybox + [data-tl-sticky-atc]. Injecting Chef’s Pan sticky fights them (flicker). */
  if (/\/products\/(sauteerpan|twee-handgrepen|wok-vlakke-bodem|hoge-rand|diepe-pan|crepepan|kookpan)(?:\/|$)/.test(pathEarly)) return;
  /* Utensils bundle is not chefs-pan-set-3 — own buybox owns ATC */
  if (/\/products\/chefs-pan-set-3-pans-titanium-utensils/.test(pathEarly)) return;
  /* TITANORE AB TEST — CHEFS PAN — VARIANT B owns its sticky; do not inject sitewide bar */
  if (pathEarly === '/pages/chefs-pan-b' || pathEarly === '/nl/pages/chefs-pan-b') return;
  if (pathEarly === '/pages/chefs-pan-tommy' || pathEarly === '/nl/pages/chefs-pan-tommy') return;
  if (pathEarly === '/collections/chefs-pan-tommy' || pathEarly === '/nl/collections/chefs-pan-tommy') return;
  if (pathEarly === '/collections/chefs-pan-tommy-b' || pathEarly === '/nl/collections/chefs-pan-tommy-b') return;
  if (pathEarly === '/pages/chef-sven-laurent' || pathEarly === '/nl/pages/chef-sven-laurent') return;
  if (pathEarly === '/pages/chefs-pan-sven' || pathEarly === '/nl/pages/chefs-pan-sven') return;
  if (/(?:^|[?&])view=chefs-pan-tommy(?:&|$)/.test(location.search || '')) return;
  if (document.querySelector && document.querySelector('.tl-tommy')) return;
  if (document.querySelector && document.querySelector('.tl-sven')) return;
  var isSetPdpEarly = pathEarly.indexOf('/products/chefs-pan-set-') !== -1;
  if (window.__tgemSiteStickyBoot && !isSetPdpEarly) return;
  if (window.__tgemSiteStickyBoot && isSetPdpEarly && document.documentElement.getAttribute('data-tl-sitewide-sticky') === 'sitewide9-set3') return;
  window.__tgemSiteStickyBoot = true;
  try {
    document.documentElement.setAttribute('data-tl-sitewide-sticky', 'sitewide9-set3');
  } catch (e) {}

  var path = pathEarly;

  /* Hosted checkout is not theme.liquid — still guard if ever injected */
  if (
    path.indexOf('/checkouts/') !== -1 ||
    path.indexOf('/checkout') !== -1 ||
    /\/(checkouts?|thank[_-]?you)/.test(path)
  ) {
    return;
  }

  /* Collection PLPs (esp. /collections/sets mobile banner) — no sitewide sticky ATC */
  if (path.indexOf('/collections/') !== -1) {
    return;
  }

  var IMG = {
    small:
      'https://cdn.shopify.com/s/files/1/1009/4254/5283/files/RegularHammeredPantternPan26.webp?v=1776593863&width=160',
    medium:
      'https://cdn.shopify.com/s/files/1/1009/4254/5283/files/Standard_1.webp?v=1776593847&width=160',
    large:
      'https://cdn.shopify.com/s/files/1/1009/4254/5283/files/8c6248e5-ac9d-4c82-add8-74f7f9cd7061.webp?v=1781731283&width=160'
  };

  /* now / was = Shopify shelf vs original compare-at (same cents as buybox). */
  var CATALOG = {
    small: {
      label: 'Small · 26 cm',
      price: '€95',
      was: '€158',
      save: '€63',
      variantId: 57830475465091,
      href: '/products/titanium-hammered-pan-pro-small',
      img: IMG.small
    },
    medium: {
      label: 'Medium · 28 cm',
      price: '€100',
      was: '€167',
      save: '€67',
      variantId: 57830474842499,
      href: '/products/titanium-hammered-pan-pro-medium',
      img: IMG.medium
    },
    large: {
      label: 'Large · 30 cm',
      price: '€105',
      was: '€175',
      save: '€70',
      variantId: 57830473302403,
      href: '/products/titanium-hammered-pan-pro-large',
      img: IMG.large
    }
  };

  var SET_CATALOG = {
    'chefs-pan-set-2': {
      title: "Chef's Pan Set",
      titleNl: "Chef's Pan-set",
      label: 'Small + Medium',
      price: '€129',
      was: '€325',
      save: '€196',
      variantId: 62341458723203,
      href: '/products/chefs-pan-set-2',
      img: 'https://cdn.shopify.com/s/files/1/1009/4254/5283/files/chefs-pan-set-2-small-medium.jpg?v=1786372983&width=160'
    },
    'chefs-pan-set-3': {
      title: "Chef's Pan Set",
      titleNl: "Chef's Pan-set",
      label: 'Small + Medium + Large',
      price: '€168',
      was: '€500',
      save: '€332',
      variantId: 62341459116419,
      href: '/products/chefs-pan-set-3',
      img: 'https://cdn.shopify.com/s/files/1/1009/4254/5283/files/chefs-pan-set-3-small-medium-large.jpg?v=1789577962&width=160'
    }
  };

  var forcedSetKey = null;

  var CART_SECTION = 'cart-drawer';
  var forcedSizeKey = null;
  var sizeSyncEnabled = false;

  /* Prefer market labels from GEM buybox size buttons (single currency). Never invent €+£. */
  function hydrateCatalogFromBuybox() {
    var SET_MAP = { set2: 'chefs-pan-set-2', set3: 'chefs-pan-set-3' };
    document.querySelectorAll('.tgem-size[data-size], [data-tgem-sizes] [data-size]').forEach(function (btn) {
      var key = btn.getAttribute('data-size');
      var price = btn.getAttribute('data-price');
      var was = btn.getAttribute('data-was');
      var save = btn.getAttribute('data-save');
      var href = btn.getAttribute('data-href');
      var variant = btn.getAttribute('data-variant');
      var img = btn.getAttribute('data-img');
      if (key && CATALOG[key]) {
        if (price) CATALOG[key].price = price;
        if (was) CATALOG[key].was = was;
        if (save) CATALOG[key].save = save;
        if (href) CATALOG[key].href = href;
        if (variant) CATALOG[key].variantId = parseInt(variant, 10) || CATALOG[key].variantId;
        if (img) CATALOG[key].img = img;
      }
      var setKey = SET_MAP[key];
      if (setKey && SET_CATALOG[setKey]) {
        if (price) SET_CATALOG[setKey].price = price;
        if (was) SET_CATALOG[setKey].was = was;
        if (save) SET_CATALOG[setKey].save = save;
        if (href) SET_CATALOG[setKey].href = href;
        if (variant) SET_CATALOG[setKey].variantId = parseInt(variant, 10) || SET_CATALOG[setKey].variantId;
        if (img) SET_CATALOG[setKey].img = img;
      }
    });
  }

  function isGemLanding() {
    return (
      path === '/pages/shop-chefs-pan' ||
      path.endsWith('/pages/shop-chefs-pan') ||
      path === '/pages/chefs-pan' ||
      path.endsWith('/pages/chefs-pan')
    );
  }

  function pdpSizeFromPath() {
    if (path.indexOf('/products/titanium-hammered-pan-pro-small') !== -1) return 'small';
    if (path.indexOf('/products/titanium-hammered-pan-pro-medium') !== -1) return 'medium';
    if (path.indexOf('/products/titanium-hammered-pan-pro-large') !== -1) return 'large';
    return null;
  }

  function pdpSetFromPath() {
    if (path.indexOf('/products/chefs-pan-set-3-pans-titanium-utensils') !== -1) return null;
    if (path.indexOf('/products/chefs-pan-set-2') !== -1) return 'chefs-pan-set-2';
    if (/\/products\/chefs-pan-set-3(?:\/|$)/.test(path)) return 'chefs-pan-set-3';
    return null;
  }

  function hasNativeGemSticky() {
    return !!(
      document.querySelector('[data-tgem-sticky]') ||
      document.getElementById('tgem-shop-sticky')
    );
  }

  function injectContrastFix() {
    if (document.getElementById('tgem-sticky-contrast-fix')) return;
    var style = document.createElement('style');
    style.id = 'tgem-sticky-contrast-fix';
    style.textContent = [
      '[data-tgem-sticky] .tgem-sticky__title,',
      '[data-tgem-sticky] .tgem-sticky__title span,',
      '#tgem-shop-sticky .tgem-ss__title,',
      '#tgem-shop-sticky .title{color:#f5f5f5!important;-webkit-text-fill-color:#f5f5f5!important}',
      '[data-tgem-sticky] .tgem-sticky__price,',
      '#tgem-shop-sticky .price{color:#a3a3a3!important;-webkit-text-fill-color:#a3a3a3!important}',
      '[data-tgem-sticky] .tgem-sticky__price strong,',
      '#tgem-shop-sticky .price strong{color:#d4b483!important;-webkit-text-fill-color:#d4b483!important}',
      '[data-tgem-sticky] .tgem-sticky__was,',
      '#tgem-shop-sticky .was{color:#a3a3a3!important;-webkit-text-fill-color:#a3a3a3!important;opacity:1!important;text-decoration:line-through}',
      '[data-tgem-sticky] .tl-ss-save,[data-tcpb-sticky] .tl-ss-save{display:inline-block;margin:0;padding:2px 6px;border:1px solid rgba(212,180,131,.7);color:#d4b483!important;-webkit-text-fill-color:#d4b483!important;font-size:10px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;white-space:nowrap}',
      '[data-tgem-sticky] .tgem-sticky__inner{grid-template-columns:auto 1fr auto!important}',
      '[data-tgem-sticky] .tgem-sticky__thumb,#tgem-shop-sticky .thumb{width:48px;height:48px;border-radius:4px;overflow:hidden;background:#2a2a2a;flex-shrink:0}',
      '[data-tgem-sticky] .tgem-sticky__thumb img,#tgem-shop-sticky .thumb img{display:block;width:100%;height:100%;object-fit:cover}',
      '#tgem-shop-sticky .cta,[data-tgem-sticky] .tgem-sticky__cta,[data-tcpb-sticky] .tcpb-sticky__cta{background:linear-gradient(168deg,#922028 0%,#7c141b 46%,#5c1016 100%)!important;background-color:#7c141b!important;color:#fff!important;-webkit-text-fill-color:#fff!important;border:1px solid rgba(255,255,255,.12)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.14),0 4px 12px rgba(92,16,22,.22)!important}',
      '#tgem-shop-sticky .cta:hover,[data-tgem-sticky] .tgem-sticky__cta:hover,[data-tcpb-sticky] .tcpb-sticky__cta:hover{background:linear-gradient(168deg,#9a222a 0%,#84161e 46%,#641016 100%)!important;background-color:#5c1016!important;filter:brightness(1.04)}',
      '@media (max-width:520px){[data-tgem-sticky] .tgem-sticky__inner{grid-template-columns:auto 1fr!important}[data-tgem-sticky] .tgem-sticky__cta{grid-column:1/-1;width:100%}}'
    ].join('');
    document.head.appendChild(style);
  }

  function demoteHeroAutoplay() {
    var vids = document.querySelectorAll(
      '.titanore-gem-siraat .tgem-hero__media video, .section-titanore-gem-buybox .tgem-hero__media video, [data-tgem-hero-video]'
    );
    vids.forEach(function (vid) {
      if (vid.getAttribute('data-ss-hero') === '1') return;
      vid.setAttribute('data-ss-hero', '1');
      try {
        vid.removeAttribute('autoplay');
        vid.autoplay = false;
        vid.preload = 'none';
        vid.pause();
      } catch (e) {}
    });
  }

  function ensureNativeStickyThumb() {
    var sticky = document.querySelector('[data-tgem-sticky]');
    if (!sticky || sticky.querySelector('[data-tgem-sticky-img]')) {
      // Still make an existing thumb clickable to pans.
      var existing = sticky && sticky.querySelector('.tgem-sticky__thumb');
      if (existing && !existing.closest('a') && existing.tagName !== 'A') {
        var parent = existing.parentNode;
        var link = document.createElement('a');
        link.href = '/pages/chefs-pan-now';
        link.className = 'tgem-sticky__thumb-link';
        link.setAttribute('aria-label', shopPanAriaLabel());
        link.style.cssText = 'display:block;line-height:0;color:inherit;text-decoration:none';
        parent.insertBefore(link, existing);
        link.appendChild(existing);
      }
      return;
    }
    var inner = sticky.querySelector('.tgem-sticky__inner');
    if (!inner) return;
    var link = document.createElement('a');
    link.href = '/pages/chefs-pan-now';
    link.className = 'tgem-sticky__thumb-link';
    link.setAttribute('aria-label', shopPanAriaLabel());
    link.style.cssText = 'display:block;line-height:0;color:inherit;text-decoration:none';
    var wrap = document.createElement('div');
    wrap.className = 'tgem-sticky__thumb';
    wrap.setAttribute('aria-hidden', 'true');
    var img = document.createElement('img');
    img.setAttribute('data-tgem-sticky-img', '');
    img.src = IMG.medium;
    img.alt = '';
    img.width = 48;
    img.height = 48;
    img.loading = 'lazy';
    img.decoding = 'async';
    wrap.appendChild(img);
    link.appendChild(wrap);
    inner.insertBefore(link, inner.firstChild);
    document.querySelectorAll('.tgem-size[data-size], [data-size]').forEach(function (el) {
      if (el.getAttribute('data-ss-thumb') === '1') return;
      el.setAttribute('data-ss-thumb', '1');
      el.addEventListener('click', function () {
        var key = el.getAttribute('data-size');
        var src = el.getAttribute('data-img') || IMG[key] || IMG.medium;
        var target = sticky.querySelector('[data-tgem-sticky-img]');
        if (target && src) target.src = src;
      });
    });
  }

  function currentLang() {
    var p = (location.pathname || '').toLowerCase();
    if (p === '/nl' || p.indexOf('/nl/') === 0) return 'nl';
    try {
      if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
        var wg = Weglot.getCurrentLang();
        if (wg) return wg;
      }
    } catch (e) {}
    var m = document.cookie.match(/(?:^|; )wglang=([^;]+)/);
    if (m) return decodeURIComponent(m[1]);
    return 'en';
  }

  function shopPanAriaLabel() {
    return currentLang() === 'nl' ? 'Chef\u2019s Pan kopen' : 'Shop Chef\u2019s Pan';
  }

  function stickyRegionAriaLabel() {
    if (currentLang() === 'nl') {
      return forcedSetKey ? 'Chef\u2019s Pan-set kopen' : 'Chef\u2019s Pan kopen';
    }
    return forcedSetKey ? 'Buy Chef\u2019s Pan set' : 'Buy Chef\u2019s Pan';
  }

  function selectedSizeKey() {
    if (forcedSizeKey && CATALOG[forcedSizeKey]) return forcedSizeKey;
    if (sizeSyncEnabled) {
      var sel = document.querySelector('.tgem-size.is-selected, [data-size].is-selected');
      var key = sel && sel.getAttribute('data-size');
      if (key && CATALOG[key]) return key;
    }
    return 'medium';
  }

  function selected() {
    if (forcedSetKey && SET_CATALOG[forcedSetKey]) return SET_CATALOG[forcedSetKey];
    return CATALOG[selectedSizeKey()];
  }

  function centsFromLabel(s) {
    if (!s) return 0;
    var t = String(s).replace(/[^\d,.]/g, '');
    if (!t) return 0;
    if (t.indexOf(',') >= 0 && t.indexOf('.') >= 0) {
      t = t.replace(/\./g, '').replace(',', '.');
    } else if (t.indexOf(',') >= 0) {
      t = t.replace(',', '.');
    }
    var n = parseFloat(t);
    if (!isFinite(n)) return 0;
    return Math.round(n * 100);
  }

  function euroFromCents(cents) {
    return '\u20ac' + Math.round(Number(cents) / 100);
  }

  /* Discount vs original compare-at, not a hardcoded campaign %. */
  function discountFrom(priceLabel, wasLabel) {
    var now = centsFromLabel(priceLabel);
    var was = centsFromLabel(wasLabel);
    if (!was || was <= now) return null;
    var save = was - now;
    var pct = Math.round((1 - now / was) * 100);
    if (pct < 1 || save < 1) return null;
    return {
      pct: pct,
      save: save,
      label: '-' + pct + '% \u00b7 \u2212' + euroFromCents(save)
    };
  }

  function hydrateCatalogFromPdp() {
    document.querySelectorAll('#tl-pan-buybox .tl-format[data-size]').forEach(function (tile) {
      var key = tile.getAttribute('data-size');
      if (!key || !CATALOG[key]) return;
      var priceEl = tile.querySelector('.tl-format__price');
      var wasEl = tile.querySelector('.tl-format__was');
      if (priceEl && priceEl.textContent) CATALOG[key].price = priceEl.textContent.trim();
      if (wasEl && wasEl.textContent) CATALOG[key].was = wasEl.textContent.trim();
    });
    var set2 = document.querySelector('#tl-pan-buybox .tl-option[data-option="set2"]');
    if (set2 && SET_CATALOG['chefs-pan-set-2']) {
      var p2 = set2.querySelector('.tl-option-price');
      var w2 = set2.querySelector('.tl-option-was');
      if (p2 && p2.textContent) SET_CATALOG['chefs-pan-set-2'].price = p2.textContent.trim();
      if (w2 && w2.textContent) SET_CATALOG['chefs-pan-set-2'].was = w2.textContent.trim();
    }
    var set3 = document.querySelector('#tl-pan-buybox .tl-option[data-option="set3"]');
    if (set3 && SET_CATALOG['chefs-pan-set-3']) {
      var p3 = set3.querySelector('.tl-option-price');
      var w3 = set3.querySelector('.tl-option-was');
      if (p3 && p3.textContent) SET_CATALOG['chefs-pan-set-3'].price = p3.textContent.trim();
      if (w3 && w3.textContent) SET_CATALOG['chefs-pan-set-3'].was = w3.textContent.trim();
    }
  }

  function setTextIfChanged(el, text) {
    if (!el) return;
    var next = text == null ? '' : String(text);
    if (el.textContent === next) return;
    el.textContent = next;
  }

  function paintStickyDiscount(root, nowLabel, wasLabel) {
    if (!root) return;
    var nowEl = root.querySelector('[data-ss-price], [data-tgem-sticky-now], [data-tcpb-sticky-now]');
    var wasEl = root.querySelector('[data-ss-was], [data-tgem-sticky-was], [data-tcpb-sticky-was]');
    var saveEl = root.querySelector('[data-ss-save], [data-tgem-sticky-save], [data-tcpb-sticky-save]');
    var disc = discountFrom(nowLabel, wasLabel);
    /* Never rewrite nowEl to the same string — textContent always replaces
       the text node and retriggers a MutationObserver on that node. */
    setTextIfChanged(nowEl, nowLabel || (nowEl ? nowEl.textContent : ''));
    if (wasEl) {
      setTextIfChanged(wasEl, disc ? wasLabel : '');
      wasEl.hidden = !disc;
      wasEl.style.display = disc ? '' : 'none';
    }
    if (saveEl) {
      setTextIfChanged(saveEl, disc ? disc.label : '');
      saveEl.hidden = !disc;
      saveEl.style.display = disc ? '' : 'none';
    }
  }

  function ensureStickySaveEl(priceRow, saveAttr) {
    if (!priceRow) return null;
    var saveEl = priceRow.querySelector('[' + saveAttr + ']');
    if (saveEl) return saveEl;
    saveEl = document.createElement('span');
    saveEl.className = 'tl-ss-save';
    saveEl.setAttribute(saveAttr, '');
    saveEl.setAttribute('data-wg-notranslate', '');
    saveEl.setAttribute('translate', 'no');
    priceRow.appendChild(saveEl);
    return saveEl;
  }

  var gemSavePatching = false;
  function patchGemStickySave() {
    if (gemSavePatching) return;
    gemSavePatching = true;
    try {
      var sticky = document.querySelector('[data-tgem-sticky]');
      if (!sticky) return;
      var priceRow = sticky.querySelector('.tgem-sticky__price');
      var nowEl = sticky.querySelector('[data-tgem-sticky-now]');
      var wasEl = sticky.querySelector('[data-tgem-sticky-was]');
      if (!priceRow || !nowEl) return;
      ensureStickySaveEl(priceRow, 'data-tgem-sticky-save');
      paintStickyDiscount(sticky, nowEl.textContent, wasEl ? wasEl.textContent : '');
    } finally {
      gemSavePatching = false;
    }
  }

  function findDrawerHost() {
    return (
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('[id*="cart-drawer" i]') ||
      document.querySelector('.cart-drawer')
    );
  }

  function replaceDrawerHtml(html) {
    if (!html) return false;
    var wrap = document.createElement('div');
    wrap.innerHTML = String(html).trim();
    var next =
      wrap.querySelector('cart-drawer') ||
      wrap.querySelector('#shopify-section-cart-drawer') ||
      wrap.querySelector('#CartDrawer') ||
      wrap.firstElementChild;
    if (!next) return false;
    var host = findDrawerHost();
    if (!host) return false;
    var section = host.closest('.shopify-section') || host;
    if (next.id && next.id.indexOf('shopify-section') === 0 && section.classList.contains('shopify-section')) {
      section.outerHTML = next.outerHTML;
    } else if (host.tagName && host.tagName.toLowerCase() === 'cart-drawer') {
      host.outerHTML = (wrap.querySelector('cart-drawer') || next).outerHTML;
    } else {
      host.innerHTML = next.innerHTML || next.outerHTML;
    }
    var drawer = findDrawerHost();
    if (drawer) {
      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') drawer.open();
      else {
        drawer.classList.add('active', 'is-open', 'animate');
        document.body.classList.add('overflow-hidden');
        document.documentElement.classList.add('tl-cart-drawer-open');
      }
      if (typeof window.tlSyncStickyForCartDrawer === 'function') window.tlSyncStickyForCartDrawer();
      else document.documentElement.classList.add('tl-cart-drawer-open');
      if (typeof window.tlRepairCartDrawer === 'function') window.tlRepairCartDrawer();
      return true;
    }
    return false;
  }

  function addToCart(btn, item) {
    if (!btn || btn.disabled || !item) return;
    var prev = btn.textContent;
    btn.disabled = true;
    btn.textContent = currentLang() === 'nl' ? 'Bezig…' : 'Adding…';
    var add = (typeof window.tlAddCookware === 'function')
      ? window.tlAddCookware(item.variantId, { sections: CART_SECTION, sections_url: window.location.pathname })
      : fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: item.variantId, quantity: 1 }],
            sections: CART_SECTION,
            sections_url: window.location.pathname
          })
        }).then(function (r) {
          if (!r.ok) throw new Error('add_failed');
          return r.json();
        });
    add
      .then(function (data) {
        if (data && data.busy) {
          btn.disabled = false;
          btn.textContent = prev;
          return;
        }
        if (typeof window.tlShouldSkipToCheckout === 'function' ? window.tlShouldSkipToCheckout() : (typeof window.tlIsMetaWebView === 'function' && window.tlIsMetaWebView())) {
          window.location.assign(typeof window.tlCheckoutHref === 'function' ? window.tlCheckoutHref() : '/nl/checkout?skip_shop_pay=true');
          return;
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        if (data && data.sections && data.sections[CART_SECTION]) {
          if (replaceDrawerHtml(data.sections[CART_SECTION])) {
            window.setTimeout(function () {
              btn.disabled = false;
              btn.textContent = prev;
            }, 700);
            /* Hide sticky so it cannot cover drawer checkout CTA */
            var sticky = document.getElementById('tgem-shop-sticky');
            if (sticky) {
              sticky.classList.remove('is-on');
              sticky.setAttribute('aria-hidden', 'true');
            }
            document.body.classList.remove('tgem-shop-sticky-pad');
            if (typeof window.tlEnsureCheckoutLinks === 'function') window.tlEnsureCheckoutLinks();
            return;
          }
        }
        var cartPath = (location.pathname || '').toLowerCase().indexOf('/nl') === 0 ? '/nl/cart' : '/cart';
        window.location.href = cartPath;
      })
      .catch(function () {
        if (typeof window.tlReleaseCartAdd === 'function') window.tlReleaseCartAdd();
        btn.disabled = false;
        btn.textContent = prev;
        window.location.href = item.href + (window.location.search || '');
      });
  }

  function usesNativeProductSticky() {
    if (!/\/products\//.test(path)) return false;
    if (/\/products\/(sauteerpan|twee-handgrepen|wok-vlakke-bodem|hoge-rand|diepe-pan|crepepan|kookpan)(?:\/|$)/.test(path)) return true;
    if (document.querySelector('[data-tl-sticky-atc]')) return true;
    if (/titanium-hammered-pan|chefs-pan-set|cutting-board|benefit-pan|benefit-board/.test(path)) return false;
    if (document.querySelector('[data-tgem-sticky]')) return false;
    return !!(document.getElementById('stickyAddToCart') || document.querySelector('[data-sticky-add-to-cart]'));
  }

  function restoreNativeProductSticky() {
    var bar = document.getElementById('tgem-shop-sticky');
    if (bar) bar.remove();
    var hideStyle = document.getElementById('tgem-hide-theme-sticky');
    if (hideStyle) hideStyle.remove();
    document.body.classList.remove('tgem-shop-sticky-pad');
  }

  function hideThemeProductSticky() {
    if (usesNativeProductSticky()) return;
    if (document.getElementById('tgem-hide-theme-sticky')) return;
    var style = document.createElement('style');
    style.id = 'tgem-hide-theme-sticky';
    style.textContent =
      '#stickyAddToCart,[data-sticky-add-to-cart]{display:none!important;visibility:hidden!important;pointer-events:none!important}';
    document.head.appendChild(style);
  }

  function injectStyles() {
    if (document.getElementById('tgem-shop-sticky-css')) return;
    var style = document.createElement('style');
    style.id = 'tgem-shop-sticky-css';
    style.textContent = [
      '#tgem-shop-sticky{position:fixed;left:0;right:0;bottom:0;top:auto;z-index:99990;padding:12px 16px calc(12px + env(safe-area-inset-bottom));background:rgba(28,28,28,.96);border-top:1px solid rgba(252,250,246,.12);visibility:hidden;pointer-events:none;font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}',
      '#tgem-shop-sticky.is-on{visibility:visible;pointer-events:auto}',
      /* Sticky below drawer z-index; fully remove while drawer open (incl. .is-on) */
      'html.tl-cart-drawer-open #tgem-shop-sticky,html.tl-cart-drawer-open #tgem-shop-sticky.is-on,body:has(cart-drawer.active) #tgem-shop-sticky,body:has(cart-drawer.active) #tgem-shop-sticky.is-on,body:has(cart-drawer.is-open) #tgem-shop-sticky,body.overflow-hidden:has(cart-drawer.active) #tgem-shop-sticky{display:none!important;visibility:hidden!important;pointer-events:none!important;z-index:-1!important}',
      'html.tl-cart-drawer-open,body:has(cart-drawer.active),body:has(cart-drawer.is-open){padding-bottom:0!important}',
      '#tgem-shop-sticky .inner{width:min(100%,720px);margin:0 auto;display:grid;grid-template-columns:auto 1fr auto;gap:12px;align-items:center}',
      '#tgem-shop-sticky .thumb{width:48px;height:48px;border-radius:4px;overflow:hidden;background:#2a2a2a;display:block;line-height:0;color:inherit;text-decoration:none}',
      '#tgem-shop-sticky .thumb img{display:block;width:100%;height:100%;object-fit:cover}',
      '#tgem-shop-sticky .tgem-ss__title{margin:0;font-size:14px;font-weight:600;line-height:1.25;color:#f5f5f5!important;-webkit-text-fill-color:#f5f5f5!important}',
      '#tgem-shop-sticky .price{margin:4px 0 0;font-size:12px;line-height:1.3;color:#a3a3a3!important;-webkit-text-fill-color:#a3a3a3!important;font-variant-numeric:tabular-nums;display:flex;flex-wrap:wrap;align-items:center;gap:6px 10px}',
      '#tgem-shop-sticky .tl-ss-price-stack{display:flex;flex-direction:column;align-items:flex-start;gap:1px;line-height:1.15}',
      '#tgem-shop-sticky .price strong,#tgem-shop-sticky .tl-ss-price-stack strong{color:#d4b483!important;-webkit-text-fill-color:#d4b483!important;font-weight:700;font-size:14px;line-height:1.1}',
      '#tgem-shop-sticky .was{display:block;text-decoration:line-through;color:#a3a3a3!important;-webkit-text-fill-color:#a3a3a3!important;opacity:1!important;margin:0;font-size:11px;line-height:1.1}',
      '#tgem-shop-sticky .tl-summer-chip,#tgem-shop-sticky .tl-ss-save{display:inline-block;margin:0;padding:2px 6px;border:1px solid rgba(212,180,131,.7);color:#d4b483!important;-webkit-text-fill-color:#d4b483!important;font-size:10px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;vertical-align:middle;flex-shrink:0;align-self:center;white-space:nowrap}',
      '#tgem-shop-sticky .cta{appearance:none;border:1px solid rgba(255,255,255,.12);min-height:44px;padding:12px 18px;background:linear-gradient(168deg,#922028 0%,#7c141b 46%,#5c1016 100%);background-color:#7c141b;color:#fff;font:inherit;font-size:13px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;border-radius:3px;cursor:pointer;white-space:nowrap;box-shadow:inset 0 1px 0 rgba(255,255,255,.14),0 4px 12px rgba(92,16,22,.22)}',
      '#tgem-shop-sticky .cta:hover{background:linear-gradient(168deg,#9a222a 0%,#84161e 46%,#641016 100%);background-color:#5c1016}',
      '#tgem-shop-sticky .cta:disabled{opacity:.65;cursor:wait}',
      '#tgem-shop-sticky .cta:focus-visible{outline:2px solid #d4b483;outline-offset:2px}',
      'body.tgem-shop-sticky-pad{padding-bottom:96px}',
      'body.tgem-shop-sticky-pad .weglot-container.wg-default{bottom:104px!important}',
      '@media (max-width:520px){#tgem-shop-sticky .inner{grid-template-columns:auto 1fr;gap:10px 12px}#tgem-shop-sticky .cta{grid-column:1/-1;width:100%}body.tgem-shop-sticky-pad{padding-bottom:calc(128px + env(safe-area-inset-bottom))}}',
      '@media (prefers-reduced-motion:reduce){#tgem-shop-sticky{transition:none}}',
      '.titanore-gem-siraat .tgem-cta,.section-titanore-gem-buybox .tgem-cta{display:inline-flex!important;align-items:center;justify-content:center;width:100%;min-height:52px;padding:16px 20px;background:#1c1c1c!important;color:#fff!important;text-decoration:none;font-size:13px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;border:0;border-radius:2px;cursor:pointer}'
    ].join('');
    document.head.appendChild(style);
  }

  function stickyCtaLabel() {
    if (currentLang() === 'nl') return forcedSetKey ? 'Set in winkelwagen' : 'In winkelwagen';
    return forcedSetKey ? 'Add set to cart' : 'Add to cart';
  }

  function ensureSticky() {
    if (document.getElementById('tgem-shop-sticky')) return document.getElementById('tgem-shop-sticky');
    var item = selected();
    var titleEn = item.title || 'Chef’s Pan';
    var titleNl = item.titleNl || titleEn;
    var titleNow = currentLang() === 'nl' ? titleNl : titleEn;
    var bar = document.createElement('div');
    bar.id = 'tgem-shop-sticky';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', stickyRegionAriaLabel());
    bar.setAttribute('data-tl-sitewide-sticky', '1');
    bar.innerHTML =
      '<div class="inner">' +
        '<a class="thumb" href="/pages/chefs-pan-now" aria-label="' +
        shopPanAriaLabel() +
        '"><img data-ss-img src="' +
        item.img +
        '" alt="" width="48" height="48" loading="lazy" decoding="async"></a>' +
        '<div>' +
          '<p class="tgem-ss__title" data-wg-notranslate translate="no">' +
          '<span data-ss-title data-en="' +
          titleEn +
          '" data-nl="' +
          titleNl +
          '">' +
          titleNow +
          '</span>' +
          ' · <span data-ss-label translate="no" data-wg-notranslate>' +
          item.label +
          '</span></p>' +
          '<p class="price">' +
            '<span class="tl-ss-price-stack">' +
              '<strong data-ss-price data-wg-notranslate translate="no">' +
              item.price +
              '</strong>' +
              '<span class="was" data-ss-was data-wg-notranslate translate="no">' +
              item.was +
              '</span>' +
            '</span>' +
            '<span class="tl-ss-save" data-ss-save data-wg-notranslate translate="no"></span>' +
          '</p>' +
        '</div>' +
        '<button type="button" class="cta" data-ss-cta data-en="' +
        (forcedSetKey ? 'Add set to cart' : 'Add to cart') +
        '" data-nl="' +
        (forcedSetKey ? 'Set in winkelwagen' : 'In winkelwagen') +
        '">' +
        stickyCtaLabel() +
        '</button>' +
      '</div>';
    document.body.appendChild(bar);
    bar.querySelector('[data-ss-cta]').addEventListener('click', function () {
      addToCart(bar.querySelector('[data-ss-cta]'), selected());
    });
    paintStickyDiscount(bar, item.price, item.was);
    return bar;
  }

  function syncSticky(bar) {
    if (!bar) return;
    var item = selected();
    var titleEl = bar.querySelector('[data-ss-title]');
    var label = bar.querySelector('[data-ss-label]');
    var img = bar.querySelector('[data-ss-img]');
    var cta = bar.querySelector('[data-ss-cta]');
    if (titleEl) {
      var tEn = item.title || titleEl.getAttribute('data-en') || 'Chef’s Pan';
      var tNl = item.titleNl || tEn;
      titleEl.setAttribute('data-en', tEn);
      titleEl.setAttribute('data-nl', tNl);
      titleEl.textContent = currentLang() === 'nl' ? tNl : tEn;
    }
    if (label) label.textContent = item.label;
    paintStickyDiscount(bar, item.price, item.was);
    if (img && item.img) img.src = item.img;
    if (cta && !cta.disabled) {
      cta.textContent = stickyCtaLabel();
    }
  }

  function findPrimaryAtcTrigger() {
    return (
      document.querySelector('#tl-pan-buybox [data-cta], #tl-pan-buybox .tl-cta') ||
      document.querySelector('[data-tgem-cta], .tgem-cta') ||
      document.querySelector('.tgem-summary') ||
      document.querySelector(
        'form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"], button[name="add"], .product-form__submit, [data-product-form] button[type="submit"]'
      )
    );
  }

  function bindStickyVisibility(bar) {
    /* Thommy 02-09: sticky ATC only after 60% page scroll. */
    var THRESHOLD = 0.6;
    var ticking = false;
    function progress() {
      var doc = document.documentElement;
      var body = document.body;
      var height = Math.max(doc ? doc.scrollHeight : 0, body ? body.scrollHeight : 0);
      var max = height - window.innerHeight;
      if (max <= 0) return 0;
      return window.scrollY / max;
    }
    function drawerOpen() {
      if (document.documentElement.classList.contains('tl-cart-drawer-open')) return true;
      var d = document.querySelector('cart-drawer');
      return !!(d && (d.classList.contains('active') || d.classList.contains('is-open')));
    }
    function update() {
      ticking = false;
      var show = !drawerOpen() && progress() >= THRESHOLD;
      bar.classList.toggle('is-on', show);
      document.body.classList.toggle('tgem-shop-sticky-pad', show);
    }
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    document.addEventListener('cart:refresh', function () { setTimeout(requestUpdate, 50); });
    update();
  }

  function upgradePrimaryCta() {
    if (!isGemLanding()) return;
    var cta = document.querySelector('[data-tgem-cta], a.tgem-cta, button.tgem-cta');
    if (!cta || cta.getAttribute('data-ss-bound') === '1') return;
    cta.setAttribute('data-ss-bound', '1');

    function labelFor() {
      return currentLang() === 'nl' ? 'Koop de Chef’s Pan' : 'Shop the Chef’s Pan';
    }

    if (cta.tagName === 'A') {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = cta.className || 'tgem-cta';
      btn.setAttribute('data-tgem-cta', '');
      btn.setAttribute('data-tgem-atc', '');
      btn.setAttribute('data-ss-bound', '1');
      btn.setAttribute('data-en', 'Shop the Chef’s Pan');
      btn.setAttribute('data-nl', 'Koop de Chef’s Pan');
      btn.textContent = labelFor();
      cta.parentNode.insertBefore(btn, cta);
      cta.remove();
      cta = btn;
    } else {
      cta.textContent = labelFor();
    }

    cta.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart(cta, selected());
    });
  }

  function bindSizeCards(bar) {
    if (!sizeSyncEnabled) return;
    document.querySelectorAll('.tgem-size, [data-size]').forEach(function (el) {
      if (el.getAttribute('data-ss-size') === '1') return;
      el.setAttribute('data-ss-size', '1');
      el.addEventListener('click', function () {
        setTimeout(function () {
          syncSticky(bar);
          var pdp = document.querySelector('[data-ss-pdp], [data-tgem-pdp-link]');
          if (pdp) pdp.href = selected().href;
        }, 0);
      });
    });
  }

  function resolveMode() {
    var setKey = pdpSetFromPath();
    if (setKey) {
      forcedSetKey = setKey;
      forcedSizeKey = null;
      sizeSyncEnabled = false;
      return 'set';
    }
    forcedSetKey = null;
    var pdp = pdpSizeFromPath();
    if (pdp) {
      forcedSizeKey = pdp;
      sizeSyncEnabled = false;
      return 'pdp';
    }
    if (
      isGemLanding() ||
      document.querySelector('.titanore-gem-siraat, .section-titanore-gem-buybox, .tgem-size[data-size]')
    ) {
      sizeSyncEnabled = !!document.querySelector('.tgem-size[data-size], [data-size].tgem-size');
      if (!sizeSyncEnabled && document.querySelector('[data-size]')) {
        sizeSyncEnabled = true;
      }
      forcedSizeKey = null;
      return 'gem';
    }
    forcedSizeKey = 'medium';
    sizeSyncEnabled = false;
    return 'default';
  }

  function init() {
    hydrateCatalogFromBuybox();
    hydrateCatalogFromPdp();
    injectContrastFix();
    demoteHeroAutoplay();
    ensureNativeStickyThumb();
    patchGemStickySave();

    /* Native GEM sticky owns the bar — contrast/thumb/discount only */
    if (document.querySelector('[data-tgem-sticky]')) {
      document.querySelectorAll('.tgem-size[data-size], [data-tgem-sizes] [data-size]').forEach(function (el) {
        if (el.getAttribute('data-ss-savebind') === '1') return;
        el.setAttribute('data-ss-savebind', '1');
        el.addEventListener('click', function () {
          window.setTimeout(patchGemStickySave, 0);
          window.setTimeout(patchGemStickySave, 80);
        });
      });
      var gemNow = document.querySelector('[data-tgem-sticky] [data-tgem-sticky-now]');
      if (gemNow && gemNow.getAttribute('data-ss-saveobs') !== '1' && typeof MutationObserver === 'function') {
        gemNow.setAttribute('data-ss-saveobs', '1');
        /* Observe the price ROW, not nowEl. Writing nowEl.textContent always
           fires childList on that node → infinite microtask loop (Chrome
           “Pagina reageert niet” on Chef’s Pan / chefs-pan-now). */
        var gemPriceRow = document.querySelector('[data-tgem-sticky] .tgem-sticky__price') || gemNow.parentNode;
        var gemSaveTimer = 0;
        var gemSaveObs = new MutationObserver(function () {
          if (gemSavePatching) return;
          window.clearTimeout(gemSaveTimer);
          gemSaveTimer = window.setTimeout(patchGemStickySave, 50);
        });
        if (gemPriceRow) {
          gemSaveObs.observe(gemPriceRow, { childList: true, subtree: true });
        }
      }
      return;
    }

    if (usesNativeProductSticky()) {
      restoreNativeProductSticky();
      return;
    }

    resolveMode();

    var existing = document.getElementById('tgem-shop-sticky');
    if (existing) {
      /* Legacy global-atc-bar / older sitewide may have defaulted to Medium on set PDPs */
      if (forcedSetKey || !existing.querySelector('[data-ss-save]')) {
        existing.remove();
        existing = null;
      } else {
        syncSticky(existing);
        return;
      }
    }

    hideThemeProductSticky();
    injectStyles();
    if (isGemLanding()) upgradePrimaryCta();
    var bar = ensureSticky();
    syncSticky(bar);
    bindStickyVisibility(bar);
    bindSizeCards(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 400);
  setTimeout(init, 1200);
})();

/* cityhash-bust 1786375400-set3-i18n-king25-conv */
/* tl-freeze-fix-20260901-gem-sticky-obs */

/* king-skill: repair single-pan PDP buybox when page_cache still loads inject v21.
   Do NOT polish sticky labels on set PDPs (would overwrite Small + Medium). */
(function () {
  if (window.__tlLinePdp) return;
  var path = (window.location.pathname || '').toLowerCase();
  var isPanPdp = /titanium-hammered-pan-pro-(small|medium|large)/.test(path);
  var isSetPdp = /chefs-pan-set-[23](?:\/|$|\?)/.test(path) && path.indexOf('utensils') === -1;
  if (!isPanPdp && !isSetPdp) return;

  function isKingBox(box) {
    if (!box) return false;
    if (box.getAttribute('data-v') === '22-king') return true;
    var t = box.textContent || '';
    return /Nothing to wear off|Geen coating|Niets dat slijt/.test(t);
  }

  function poisonOldInject() {
    var box = document.getElementById('tl-pan-buybox');
    if (!isKingBox(box)) return;
    var ver = box.getAttribute('data-v') || '';
    if (/^4[0-9]/.test(ver)) return;
    /* Legacy inject BOX_VERSION=21 skips replace when data-v matches + [data-slots] */
    box.setAttribute('data-v', '21');
    box.setAttribute('data-tl-ready', '1');
  }

  function polishSticky() {
    if (!isPanPdp) return;
    var map = { small: 'Small · 26 cm', medium: 'Medium · 28 cm', large: 'Large · 30 cm' };
    var key = /small/.test(path) ? 'small' : /large/.test(path) ? 'large' : 'medium';
    document.querySelectorAll('#tgem-shop-sticky [data-ss-label], [data-tgem-sticky] [data-ss-label]').forEach(function (el) {
      el.textContent = map[key];
      el.setAttribute('data-wg-notranslate', '');
      el.setAttribute('translate', 'no');
    });
  }

  function loadKing() {
    /* Theme loads king25. Do not inject leftover king24. */
    if (!isPanPdp) return;
    poisonOldInject();
  }

  function boot() {
    loadKing();
    polishSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setTimeout(boot, 200);
  setTimeout(boot, 700);
  setTimeout(boot, 1400);
  setTimeout(boot, 2200);
})();

/* tl-media-cover-20260811: edge-to-edge demo cards + copy fixes even when page_cache is stale */
(function () {
  var path = (location.pathname || '').toLowerCase();
  if (path !== '/pages/shop-chefs-pan' && path !== '/nl/pages/shop-chefs-pan') return;

  function injectCss() {
    var old = document.getElementById('tl-pan-fullvis-override');
    if (old) old.remove();
    if (document.getElementById('tl-media-cover-override')) return;
    var style = document.createElement('style');
    style.id = 'tl-media-cover-override';
    style.textContent = [
      '.tgem-hero__media{background:#f3eee6!important;overflow:hidden!important;aspect-ratio:4/3!important;max-height:min(70vh,480px)!important;}',
      '.tgem-hero__media img,.tgem-hero__media video{width:100%!important;height:100%!important;min-height:0!important;max-height:none!important;object-fit:contain!important;object-position:center!important;background:#f3eee6!important;}',
      '.titanore-demo-strip .tds-card__media{aspect-ratio:4/5!important;background:#1a1a1a!important;}',
      '.titanore-demo-strip .tds-card__media img,.titanore-demo-strip .tds-card__media video{object-fit:cover!important;object-position:center!important;background:transparent!important;}'
    ].join('');
    (document.head || document.documentElement).appendChild(style);
  }

  function fixCopy() {
    var lang = path.indexOf('/nl') === 0 ? 'nl' : 'en';
    var root = document.querySelector('.titanore-demo-strip');
    if (root) {
      root.querySelectorAll('[data-en][data-nl]').forEach(function (el) {
        if (el.classList.contains('tds-sub')) {
          el.setAttribute('data-en', 'Eggs that release. Quick clean. Metal utensils welcome. No coating that wears off.');
          el.setAttribute('data-nl', 'Eieren die loslaten. Snel schoon. Metalen gerei mag. Geen coating die slijt.');
        } else if (el.classList.contains('tds-title')) {
          el.setAttribute('data-en', 'How the cooking surface works');
          el.setAttribute('data-nl', 'Zo werkt je pan');
        } else {
          ['data-en', 'data-nl'].forEach(function (attr) {
            var v = el.getAttribute(attr);
            if (v && /[\u2013\u2014]/.test(v)) {
              el.setAttribute(attr, v.replace(/[\u2013\u2014]/g, '. ').replace(/\s{2,}/g, ' ').trim());
            }
          });
        }
        var next = el.getAttribute('data-' + lang) || el.getAttribute('data-en');
        if (next == null) return;
        if (/<\/?[a-z][\s\S]*>/i.test(next)) el.innerHTML = next;
        else el.textContent = next;
      });
    }
    var h1 = document.querySelector('[data-tgem-buy] h1');
    if (h1) {
      h1.setAttribute('data-en', 'No coating. Nothing to wear off.');
      h1.setAttribute('data-nl', 'Geen coating. Niets dat slijt.');
      h1.textContent = lang === 'nl' ? 'Geen coating. Niets dat slijt.' : 'No coating. Nothing to wear off.';
    }
  }

  function run() {
    injectCss();
    fixCopy();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  setTimeout(run, 200);
  setTimeout(run, 800);
  setTimeout(run, 1600);
})();
/* tl-hero-lift-inject-20260811c */
(function(){try{var path=(location.pathname||'').toLowerCase();if(!(/\/pages\/(buy-chefs-pan|chefs-pan|shop-chefs-pan|chefs-pan-buy)/.test(path)||/\/nl\/pages\/(buy-chefs-pan|chefs-pan|shop-chefs-pan|chefs-pan-buy)/.test(path)))return;var css="[data-tgem-buy] .tgem-hero__media img,[data-tgem-buy] .tgem-hero__media video{filter:brightness(1.22) contrast(1.06)!important}[data-tgem-buy] .tgem-hero::after{background:linear-gradient(180deg,rgba(0,0,0,.08) 0%,rgba(0,0,0,.14) 42%,rgba(0,0,0,.52) 78%,rgba(0,0,0,.68) 100%)!important}@media (min-width:900px){[data-tgem-buy] .tgem-hero::after{background:linear-gradient(90deg,rgba(0,0,0,.55) 0%,rgba(0,0,0,.28) 36%,rgba(0,0,0,.08) 62%,rgba(0,0,0,0) 100%),linear-gradient(180deg,rgba(0,0,0,.08) 0%,rgba(0,0,0,.04) 50%,rgba(0,0,0,.32) 100%)!important}}";var s=document.getElementById("tl-hero-lift-live");if(!s){s=document.createElement("style");s.id="tl-hero-lift-live";(document.documentElement||document.head).appendChild(s);}s.textContent=css;function fixSale(){var sale=document.querySelector(".titanore-offer-bar .tob-sale");if(sale){sale.querySelectorAll(".tob-mark").forEach(function(m){m.remove();});sale.textContent="40% SUMMER DISCOUNT";}document.querySelectorAll("#okhSummerStrip,#tlSummerStripLive").forEach(function(el){el.remove();});}fixSale();setTimeout(fixSale,400);setTimeout(fixSale,1200);}catch(e){}})();


/* tl-opta-ghost-hydra-20260811 */
(function(){
  try{
    var S=window.Shopify||{};
    if(S.designMode||S.visualPreviewMode) return;
    if(S.inspect&&S.inspect.preview) return;
    if((location.search||'').indexOf('preview_theme_id=')!==-1) return;
    var path=(location.pathname||'').toLowerCase().replace(/\/$/,'');
    if(path!=='/pages/chefs-pan-buy' && path!=='/nl/pages/chefs-pan-buy') return;
    if(/[?&]view=chefs-pan-optA/.test(location.search)) return;
    if(document.querySelector('[data-size="set2"], .section-titanore-gem-buybox-sets, .tgem-size-div')) return;
    if(window.__tlOptAHydra) return; window.__tlOptAHydra=1;
    var qs=location.search||'';
    if(qs && qs.charAt(0)==='?') qs=qs.slice(1);
    qs=qs.replace(/(^|&)view=[^&]*/g,'').replace(/^&/, '');
    var next=path+'?view=chefs-pan-optA'+(qs?'&'+qs:'')+location.hash;
    location.replace(next);
  }catch(e){}
})();
